import { FormEdit as FormEditComponent } from './FormEdit.component';
import { connector } from './FormEdit.connector';

export const FormEdit = connector(FormEditComponent);
